const IDLE_MS = 5 * 60 * 1000;
const WARN_BEFORE_MS = 1 * 60 * 1000;
const COUNTDOWN_SEC = WARN_BEFORE_MS / 1000;

const SESSION_TIMEOUT = {
  IDLE_MS,
  WARN_BEFORE_MS,
  COUNTDOWN_SEC,
};

export { SESSION_TIMEOUT };
